(() => {
  if (customElements.get('ulviva-privacy-preferences')) return;
  class UlvivaPrivacyPreferences extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      const refresh = () => { this.hidden = typeof window.privacyBanner?.showPreferences !== 'function'; };
      this.querySelector('button')?.addEventListener('click', async () => {
        if (typeof window.privacyBanner?.showPreferences !== 'function') { refresh(); return; }
        try { await window.privacyBanner.showPreferences(); } catch { this.hidden = true; }
      }, options);
      window.addEventListener('load', refresh, options);
      document.addEventListener('visitorConsentCollected', refresh, options);
      window.addEventListener('focus', refresh, options);
      let attempts = 0;
      this.timer = setInterval(() => { refresh(); if (!this.hidden || ++attempts >= 120) clearInterval(this.timer); }, 250);
      refresh();
    }
    disconnectedCallback() { clearInterval(this.timer); this.events?.abort(); this.events = null; }
  }
  customElements.define('ulviva-privacy-preferences', UlvivaPrivacyPreferences);
})();
